<template>
  <div
    role="status"
    class="w-full cards__item pe-[15px] md:pe-[10px] ps-[15px] md:ps-[10px] pb-7 md:pb-10 nach"
  >
    <div class="border-0">
      <div
        class="flex items-center justify-center h-48 mb-4 bg-gray-200 rounded dark:bg-gray-500"
      >
        <svg
          class="w-10 h-10 text-white dark:text-gray-100"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 16 20"
        >
          <path
            d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z"
          />
          <path
            d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z"
          />
        </svg>
      </div>
      <div
        class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-500 w-48 mb-4"
      ></div>
      <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-500 mb-2.5"></div>
      <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-500 mb-2.5"></div>
      <div class="mt-4 text-right">
        <div
          class="mt-8 h-3 bg-gray-200 rounded-full dark:bg-gray-500 w-30"
        ></div>
        <button
          disabled
          tabindex="-1"
          class="select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-4 px-10 rounded-full text-white shadow-gray-900/10 hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none h-8 w-20 bg-gray-300 shadow-none hover:shadow-none"
          type="button"
        >
          &nbsp;
        </button>
      </div>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>
<script setup lang="ts">
</script>